<template>
    <CRow>
        <CCol>
            <CCard v-if="entity">
                <CCardHeader>
                    <strong>{{ entity.title }}</strong>
                </CCardHeader>
                <CCardBody>
                    <SurveyResultCard :entity="entity" :results="results" />
                </CCardBody>

                <CCardFooter>
                    <CButton
                        color="primary"
                        @click="$router.push(`/surveys/${ entity.id}`)"
                    >Назад</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import SurveyResultCard from '@/components/surveys/SurveyResultCard';

    export default {
        name: 'SurveyResult',

        components: {
            SurveyResultCard,
        },

        data() {
            return {
                entity: {},
                results: []
            };
        },

        async created() {
            await this.fetch();
        },

        methods: {
            async fetch() {
                const { id, customer_id } = this.$route.params;
                this.entity = (await this.axios.get(`/surveys/${id}`)).data;
                this.results = (await this.axios.get(`/surveys/${id}/results/${customer_id}`)).data;
            },
        },
    };
</script>
